const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Confere o formato antes de usar um uuid recebido do cliente numa consulta. */
export const ehUuid = (valor: string) => UUID.test(valor);

export function removerAcentos(texto: string) {
  return texto.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

/** Forma usada para comparar termos de busca: minúsculas, sem acentos e com espaços simples. */
export function normalizarBusca(texto: string) {
  return removerAcentos(texto).toLowerCase().trim().replace(/\s+/g, ' ');
}

/** Iniciais para avatares: primeira letra do primeiro e do último nome. */
export function iniciais(nome: string) {
  const palavras = nome.trim().split(/\s+/).filter(Boolean);
  if (palavras.length === 0) return '';
  const primeira = palavras[0]!.charAt(0);
  const ultima = palavras.length > 1 ? palavras.at(-1)!.charAt(0) : '';
  return (primeira + ultima).toUpperCase();
}
